module.exports = __webpack_public_path__ + "static/assets/a312db91e5bac2890a1c753b142fc0af.png";